<template>
  <div id="app">
    <router-view/>
		<!-- 购物车 -->
		
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
	#app,html,body{
		margin: 0px;
		width: 100%;
		height: 100%;
	}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>



// WEBPACK FOOTER //
// src/App.vue